/**
 * LION SPORT CLUB — HEADER PREMIUM
 * Shopify Horizon 4.1.3
 *
 * Añade una clase al elemento <html> cuando el usuario
 * ha comenzado a desplazarse por la página.
 */

(() => {
  "use strict";

  const ROOT_CLASS = "lion-header-scrolled";
  const SCROLL_THRESHOLD = 16;

  let ticking = false;

  const updateHeaderState = () => {
    const hasScrolled = window.scrollY > SCROLL_THRESHOLD;

    document.documentElement.classList.toggle(
      ROOT_CLASS,
      hasScrolled
    );

    ticking = false;
  };

  const handleScroll = () => {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateHeaderState);
  };

  window.addEventListener("scroll", handleScroll, {
    passive: true
  });

  window.addEventListener("pageshow", updateHeaderState);

  document.addEventListener(
    "shopify:section:load",
    updateHeaderState
  );

  document.addEventListener(
    "shopify:section:reorder",
    updateHeaderState
  );

  updateHeaderState();
})();